// Client d'authentification côté serveur (ADR 0004 / session cookie).
// Toutes les requêtes incluent les cookies (credentials) : l'identité est
// portée par le serveur, jamais par un jeton ou un document stocké localement.
// En développement, webpack relaie /auth vers le backend. Le build Netlify
// utilise l'origine API configurée explicitement (src/config.js).
import { apiPath } from "./baseUrl";

const AUTH_ROUTE = "/auth";

// Ne rejette jamais : retourne { status, data } pour qu'un appelant puisse
// toujours afficher un retour (y compris en cas d'erreur réseau / CORS).
const request = async (path, { method = "GET", body } = {}) => {
  try {
    const response = await fetch(apiPath(`${AUTH_ROUTE}${path}`), {
      method,
      credentials: "include", // cookie session httpOnly
      headers: body ? { "content-type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (response.status === 204) {
      return { status: response.status, data: null };
    }

    const data = await response.json().catch(() => ({}));
    return { status: response.status, data };
  } catch {
    // Réseau / CORS / proxy indisponible : on renvoie un statut "non joignable"
    // pour que l'UI affiche un message au lieu de rester silencieuse.
    return { status: 0, data: { message: "Indisponible." } };
  }
};

export const authApi = {
  register: (payload) =>
    request("/register", { method: "POST", body: payload }),
  confirm: (payload) =>
    request("/confirm", { method: "POST", body: payload }),
  login: (payload) =>
    request("/login", { method: "POST", body: payload }),
  logout: () => request("/logout", { method: "POST" }),
  forgotPassword: (payload) =>
    request("/forgot-password", { method: "POST", body: payload }),
  resetPassword: (payload) =>
    request("/reset-password", { method: "POST", body: payload }),
  me: () => request("/me"),
};

export default authApi;
